<template>
  <div class="list-section">
    <!-- 搜索区域 -->
    <div class="search-bg">
      <el-row :gutter="20">
        <el-col :span="4">
          <el-form-item :label="$t('proxy.text88') + '：'" class="search-label">
            <el-input
              v-model="filters.customerName"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="agentConfig.phoneLoginReg">
          <el-form-item
            :label="$t('followOrder.text6') + '：'"
            class="search-label"
          >
            <el-input
              v-model="filters.phone"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4" v-if="agentConfig.emailLoginReg">
          <el-form-item :label="$t('proxy.text34') + '：'" class="search-label">
            <el-input
              v-model="filters.email"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text7') + '：'"
            class="search-label"
          >
            <el-input
              v-model="filters.fundAccountId"
              placeholder=""
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item
            :label="$t('followOrder.text71') + '：'"
            class="search-label"
          >
            <el-select v-model="filters.status" placeholder="" clearable>
              <el-option
                :label="$t('followOrder.text72')"
                value="0"
              ></el-option>
              <el-option
                :label="$t('followOrder.text73')"
                value="1"
              ></el-option>
              <el-option
                :label="$t('followOrder.text74')"
                value="2"
              ></el-option>
              <el-option
                :label="$t('followOrder.text75')"
                value="99"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <!-- 第二行 -->
      <el-row :gutter="20" style="margin-top: 10px">
        <el-col :span="7">
          <el-form-item
            :label="$t('followOrder.text126') + '：'"
            class="search-label"
          >
            <el-date-picker
              v-model="filters.followTimeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              placeholder=""
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$t('followOrder.text81') + '：'"
            class="search-label"
          >
            <el-date-picker
              v-model="filters.unfollowTimeRange"
              type="daterange"
              range-separator="-"
              :start-placeholder="$t('proxy.text201')"
              :end-placeholder="$t('proxy.text202')"
              placeholder=""
              format="MM/DD/YYYY"
              value-format="YYYY-MM-DD"
            />
          </el-form-item>
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            @click="handleSearch"
            class="search-button"
            >{{ $t("proxy.text13") }}</el-button
          >
        </el-col>
      </el-row>
    </div>

    <div class="list-spacer"></div>

    <!-- 表格列表 -->
    <div class="table-container">
      <el-table :data="displayedData" style="width: 100%" v-loading="loading">
        <el-table-column
          min-width="100px"
          prop="userId"
          :label="$t('proxy.text84')"
          align="center"
        />
        <el-table-column
          min-width="130px"
          prop="customerName"
          :label="$t('proxy.text88')"
          align="center"
        />
        <el-table-column
          v-if="agentConfig.phoneLoginReg"
          min-width="100px"
          prop="phone"
          :label="$t('followOrder.text6')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.phone === "" ? "--" : scope.row.phone }}</span>
          </template>
        </el-table-column>
        <el-table-column
          v-if="agentConfig.emailLoginReg"
          min-width="130px"
          prop="email"
          :label="$t('proxy.text34')"
          align="center"
        >
          <template #default="scope">
            <span>{{ scope.row.email === "" ? "--" : scope.row.email }}</span>
          </template>
        </el-table-column>
        <el-table-column
          min-width="120px"
          prop="webAccountName"
          :label="$t('followOrder.text7')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="followAmount"
          :label="$t('followOrder.text78')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="100px"
          prop="followDay"
          :label="$t('followOrder.text79')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="followDate"
          :label="$t('followOrder.text126')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="120px"
          prop="relieveDateDesc"
          :label="$t('followOrder.text81')"
          align="center"
          :formatter="formatCell"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="totalTradeNum"
          :label="$t('followOrder.text82')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="150px"
          prop="quantity"
          :label="$t('followOrder.text83')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="100px"
          prop="winrate"
          :label="$t('followOrder.text84')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="100px"
          prop="closeProfit"
          :label="$t('proxy.text115')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="100px"
          prop="avgProfit"
          :label="$t('followOrder.text85')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="100px"
          prop="avgLoss"
          :label="$t('followOrder.text86')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="100px"
          prop="maxDrawdown"
          :label="$t('followOrder.text18')"
          align="center"
        ></el-table-column>
        <el-table-column
          min-width="280px"
          :label="$t('followOrder.text87')"
          align="center"
          fixed="right"
        >
          <template #default="scope">
            <el-button
              class="follow-record"
              @click="showFollowOperation(scope.row.uniqueCode)"
              >{{ $t("followOrder.text90") }}</el-button
            >
            <el-button
              class="fond-record"
              @click="showCapitalOperation(scope.row.uniqueCode)"
              >{{ $t("followOrder.text98") }}</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-size="pagination.pageSize"
        :total="pagination.total"
        :page-sizes="[10, 50, 100, 200]"
        :disabled="false"
        :background="true"
        layout="total, prev, pager, next, sizes"
        class="pagination-container"
      />

      <!-- 跟随操作记录弹窗 -->
      <el-dialog
        :title="$t('followOrder.text88')"
        v-model="followOperationDialogVisible"
        width="50%"
        class="follow-operation-dialog"
      >
        <el-table :data="followOperationData" style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="optType"
            :label="$t('followOrder.text91')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="optTime"
            :label="$t('followOrder.text94')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="optTypeMark"
            :label="$t('followOrder.text95')"
            align="center"
          ></el-table-column>
        </el-table>
      </el-dialog>

      <!-- 资金操作记录弹窗 -->
      <el-dialog
        :title="$t('followOrder.text129')"
        v-model="capitalOperationDialogVisible"
        width="50%"
        class="capital-operation-dialog"
      >
        <el-table :data="capitalOperationData" style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="optType"
            :label="$t('followOrder.text91')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="optTime"
            :label="$t('followOrder.text94')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="amount"
            :label="$t('followOrder.text99')"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="blanance"
            :label="$t('followOrder.text100')"
            align="center"
          ></el-table-column>
        </el-table>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { ref, reactive, onMounted, computed } from "vue";
import { useStore } from "vuex";
import apiService from "@/api/request";

export default {
  setup() {
    const followOperationDialogVisible = ref(false);
    const capitalOperationDialogVisible = ref(false);
    const followOperationData = ref([]);
    const capitalOperationData = ref([]);
    const loading = ref(false);
    const store = useStore();
    const agentConfig = computed(() => store.getters.getAgentConfig);
    const filters = reactive({
      customerName: "",
      phone: "",
      email: "",
      fundAccountId: "",
      status: "",
      followTimeRange: [],
      unfollowTimeRange: [],
    });

    const pagination = reactive({
      currentPage: 1,
      pageSize: 10,
      total: 0,
    });

    const displayedData = ref([]);

    const fetchData = async () => {
      loading.value = true;
      const params = {
        userToken:
          store.getters.userToken !== "" ? store.getters.userToken : "x",
        customerName: filters.customerName,
        phone: filters.phone,
        email: filters.email,
        fundAccountId: filters.fundAccountId,
        status: filters.status,
        followDateStart: filters.followTimeRange
          ? filters.followTimeRange.length
            ? filters.followTimeRange[0]
            : ""
          : "",
        followDateEnd: filters.followTimeRange
          ? filters.followTimeRange.length
            ? filters.followTimeRange[1]
            : ""
          : "",
        relieveDateStart: filters.unfollowTimeRange
          ? filters.unfollowTimeRange.length
            ? filters.unfollowTimeRange[0]
            : ""
          : "",
        relieveDateEnd: filters.unfollowTimeRange
          ? filters.unfollowTimeRange.length
            ? filters.unfollowTimeRange[1]
            : ""
          : "",
        page: pagination.currentPage,
        limit: pagination.pageSize,
      };

      try {
        const response = await apiService.followSubRecordList(params);
        const { followSubRecords, count } = response.data;
        displayedData.value = followSubRecords;
        pagination.total = count;
      } catch (error) {
        console.error("Error fetching follow records:", error);
      } finally {
        loading.value = false;
      }
    };

    const showFollowOperation = async (uniqueCode) => {
      loading.value = true;
      try {
        const response = await apiService.followSubRecordOptLogList({
          userToken:
            store.getters.userToken !== "" ? store.getters.userToken : "x",
          uniqueCode,
          page: 1,
          limit: 10,
        });
        followOperationData.value = response.data.logs;
        followOperationDialogVisible.value = true;
      } catch (error) {
        console.error("Error fetching follow operation logs:", error);
      } finally {
        loading.value = false;
      }
    };

    const showCapitalOperation = async (uniqueCode) => {
      loading.value = true;
      try {
        const response = await apiService.followSubRecordOptLogList({
          userToken:
            store.getters.userToken !== "" ? store.getters.userToken : "x",
          uniqueCode,
          type: 2,
          page: 1,
          limit: 10,
        });
        capitalOperationData.value = response.data.logs;
        capitalOperationDialogVisible.value = true;
      } catch (error) {
        console.error("Error fetching capital operation logs:", error);
      } finally {
        loading.value = false;
      }
    };

    const handleSearch = () => {
      pagination.currentPage = 1;
      fetchData();
    };

    const handleSizeChange = (val) => {
      pagination.pageSize = val;
      pagination.currentPage = 1;
      fetchData();
    };

    const handleCurrentChange = (val) => {
      pagination.currentPage = val;
      fetchData();
    };

    onMounted(() => {
      fetchData();
    });

    const formatCell = (row, column, cellValue, index) => {
      return cellValue === "" || cellValue === null ? "--" : cellValue;
    };

    return {
      followOperationDialogVisible,
      capitalOperationDialogVisible,
      followOperationData,
      capitalOperationData,
      loading,
      filters,
      pagination,
      displayedData,
      showFollowOperation,
      showCapitalOperation,
      handleSearch,
      handleSizeChange,
      handleCurrentChange,
      formatCell,
      agentConfig,
    };
  },
};
</script>

<style lang="less" scoped>
.follow-record,
.fond-record {
  font-size: 14px;
  border: none;
}
.follow-record {
  color: @primary-color;
}

.fond-record {
  color: @success-color;
}

.pagination-container {
  margin-top: 20px;
}
</style>
